import { useMutation } from '@tanstack/react-query'
import AXIOS_INSTANCE from '../api/axiosInstance'

interface UploadFileResponse {
  signed_id: string
}

export const useUploadFile = () => {
  const { mutateAsync: uploadFile, isPending: isUploading } = useMutation({
    mutationFn: async (file: File): Promise<UploadFileResponse> => {
      const formData = new FormData()
      formData.append('file', file)

      const { data } = await AXIOS_INSTANCE.post<UploadFileResponse>('/uploads', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })

      return data
    }
  })

  const { mutateAsync: deleteUpload, isPending: isDeleting } = useMutation({
    mutationFn: async (signed_id: string): Promise<void> => {
      await AXIOS_INSTANCE.delete(`/uploads?signed_id=${signed_id}`)
    }
  })

  return {
    deleteUpload,
    isDeleting,
    isUploading,
    uploadFile
  }
}
